module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "quan"
    }
  }, [_c('div', {
    staticClass: "quan"
  }, [_c('div', {
    staticClass: "info",
    style: ('background-image:url(' + _vm.imgPath + 'quan/quan-bg.png)')
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "use"
  }, [(_vm.quan.enabled == 'yes') ? _c('span', [_vm._v("未使用")]) : _c('span', [_vm._v("已使用")])]), _vm._v(" "), _c('div', {
    staticClass: "head-card"
  }, [_c('div', {
    staticClass: "head-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.quan.pic_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "head-right"
  }, [_c('p', [_vm._v("商户名称：" + _vm._s(_vm.quan.ds_name))]), _vm._v(" "), _c('p', [_vm._v("卡号：" + _vm._s(_vm.quan.code))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "explain"
  }, [_c('li', [_c('span', [_vm._v("卡券类型：")]), _vm._v(" "), (_vm.quan.type == 'discount') ? _c('p', [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'money') ? _c('p', [_vm._v("代金券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'gift') ? _c('p', [_vm._v("礼品券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'coupon') ? _c('p', [_vm._v("优惠券")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('span', [_vm._v("销券方式：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.ds_name))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("有效期：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.use_time) + " - " + _vm._s(_vm.quan.use_time))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("使用说明：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.quan.ds_name))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("立即使用")]), _vm._v(" "), _c('p', {
    staticClass: "master"
  }, [_vm._v("最终解释权归活动举办方所有")]), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, [_c('div', {
    staticClass: "coupon",
    style: ('background-image:url(' + _vm.imgPath + 'quan/quan-bg2.jpg)')
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('img', {
    staticClass: "year",
    attrs: {
      "src": _vm.imgPath + 'quan/2018.png',
      "alt": "2017"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "dog",
    attrs: {
      "src": _vm.imgPath + 'quan/dog.png',
      "alt": "小狗"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupontext"
  }, [(_vm.quan.type == 'discount') ? _c('p', [_vm._v("折扣券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'money') ? _c('p', [_vm._v("代金券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'gift') ? _c('p', [_vm._v("礼品券")]) : _vm._e(), _vm._v(" "), (_vm.quan.type == 'coupon') ? _c('p', [_vm._v("优惠券")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Raffle ticket")]), _c('p', [_vm._v("●●●●")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bolls"
  }, [_c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  }), _vm._v(" "), _c('div', {
    staticClass: "boll"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('h3', [_vm._v("中秋月饼优惠券")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("（ 总购物金额满200元可用 ）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "rcircle"
  }), _vm._v(" "), _c('div', {
    staticClass: "wcircle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb277094"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/quan.vue
// module id = 471
// module chunks = 0